export default {"src":"/_next/static/media/pub-restaurant-icon.992cf54a.svg","height":70,"width":80,"blurWidth":0,"blurHeight":0};